/* eslint-disable sonarjs/no-duplicate-string */
import { __awaiter, __generator } from "tslib";
var BaseController = /** @class */ (function () {
    function BaseController(controllerParams) {
        var _this = this;
        this.reportFedopsInteraction = function (interaction, fn) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.flowAPI.fedops.interactionStarted(interaction);
                        return [4 /*yield*/, fn()];
                    case 1:
                        _a.sent();
                        this.flowAPI.fedops.interactionEnded(interaction);
                        return [2 /*return*/];
                }
            });
        }); };
        this.flowAPI = controllerParams.flowAPI;
        this.platformAPIs = controllerParams.controllerConfig.platformAPIs;
        this.publicData = controllerParams.controllerConfig.config.publicData;
        this.setProps = controllerParams.controllerConfig.setProps;
        this.siteStore = controllerParams.appData.context.siteStore;
    }
    Object.defineProperty(BaseController.prototype, "t", {
        get: function () {
            return this.flowAPI.translations.t;
        },
        enumerable: false,
        configurable: true
    });
    return BaseController;
}());
export { BaseController };
//# sourceMappingURL=BaseController.js.map